// Full NARA Nutrition formulation, grouped by system.
// Per-category Tailwind classes are written as full literal strings so they are picked up by the JIT compiler.

export const INGREDIENT_GROUPS = [
  {
    category: "Gut Health",
    icon: "Leaf",
    bg: "bg-emerald-50",
    fg: "text-emerald-600",
    line: "from-emerald-400",
    ingredients: [
      { name: "L-Glutamine", amount: "5,000 mg", benefit: "Repairs gut lining" },
      { name: "Inulin (Agave)", amount: "3,000 mg", benefit: "Feeds beneficial bacteria" },
      { name: "Digestive Enzyme Blend", amount: "200 mg", benefit: "Improves digestion" },
      { name: "Zinc Carnosine", amount: "37.5 mg", benefit: "Protects gut lining" },
      { name: "Saccharomyces boulardii", amount: "5 billion CFU", benefit: "Supports microbiome balance" },
      { name: "Bacillus coagulans BC99", amount: "2 billion CFU", benefit: "Aids digestion" },
      { name: "Bacillus subtilis DE111", amount: "1 billion CFU", benefit: "Improves gut resilience" },
      { name: "Postbiotic Blend", amount: "25 mg", benefit: "Supports gut immune signaling" },
    ],
  },
  {
    category: "Energy & Cellular Metabolism",
    icon: "Zap",
    bg: "bg-amber-50",
    fg: "text-amber-600",
    line: "from-amber-400",
    ingredients: [
      { name: "Vitamin B1 (Thiamin)", amount: "2 mg", benefit: "Energy conversion" },
      { name: "Vitamin B2 (Riboflavin)", amount: "2 mg", benefit: "Mitochondrial support" },
      { name: "Vitamin B3 (Niacinamide)", amount: "16 mg", benefit: "NAD+ production" },
      { name: "Vitamin B5 (Pantothenic Acid)", amount: "10 mg", benefit: "Adrenal energy support" },
      { name: "Vitamin B6", amount: "2 mg", benefit: "Amino acid metabolism" },
      { name: "Folate (5-MTHF)", amount: "400 mcg", benefit: "Cellular repair" },
      { name: "Vitamin B12 (Methylcobalamin)", amount: "500 mcg", benefit: "Nerve and energy support" },
      { name: "Magnesium Bisglycinate", amount: "100 mg", benefit: "Muscle and nerve function" },
      { name: "Potassium Citrate", amount: "300 mg", benefit: "Electrolyte balance" },
      { name: "Acetyl-L-Carnitine", amount: "750 mg", benefit: "Mitochondrial energy" },
      { name: "Alpha-Lipoic Acid", amount: "200 mg", benefit: "Metabolic antioxidant" },
      { name: "CoQ10 (water-dispersible)", amount: "100 mg", benefit: "Cellular energy production" },
    ],
  },
  {
    category: "Focus & Mental Clarity",
    icon: "Brain",
    bg: "bg-violet-50",
    fg: "text-violet-600",
    line: "from-violet-400",
    ingredients: [
      { name: "Citicoline (CDP-Choline)", amount: "250 mg", benefit: "Focus and memory" },
      { name: "Lion's Mane Mushroom Extract", amount: "500 mg", benefit: "Nerve growth support" },
      { name: "Rhodiola Rosea", amount: "150 mg", benefit: "Mental resilience" },
      { name: "L-Theanine", amount: "200 mg", benefit: "Calm focus" },
      { name: "Bacopa Monnieri (50% bacosides)", amount: "300 mg", benefit: "Memory retention" },
    ],
  },
  {
    category: "Libido, Vitality & Mood",
    icon: "Heart",
    bg: "bg-rose-50",
    fg: "text-rose-500",
    line: "from-rose-400",
    note: "Daily-Safe",
    ingredients: [
      { name: "Vitamin D3", amount: "50 mcg (2,000 IU)", benefit: "Hormone balance" },
      { name: "Vitamin K2 (MK-7)", amount: "100 mcg", benefit: "Vascular health" },
      { name: "Zinc Bisglycinate", amount: "15 mg", benefit: "Reproductive health" },
      { name: "Maca Root Extract (gelatinized)", amount: "1,500 mg", benefit: "Libido and mood support" },
      { name: "Saffron Extract", amount: "30 mg", benefit: "Mood and sexual well-being" },
    ],
  },
  {
    category: "Fitness, Recovery & Structural Health",
    icon: "Dumbbell",
    bg: "bg-orange-50",
    fg: "text-orange-600",
    line: "from-orange-400",
    ingredients: [
      { name: "Collagen Peptides (hydrolyzed)", amount: "5,000 mg", benefit: "Joint and skin support" },
      { name: "MSM", amount: "1,000 mg", benefit: "Joint comfort" },
      { name: "Beta-Alanine", amount: "2,000 mg", benefit: "Muscular endurance" },
      { name: "Sodium (Sea Salt)", amount: "300 mg", benefit: "Hydration and performance" },
      { name: "Glycine", amount: "3,000 mg", benefit: "Recovery and sleep quality" },
    ],
  },
  {
    category: "Longevity & Healthy Aging",
    icon: "Infinity",
    bg: "bg-sky-50",
    fg: "text-sky-600",
    line: "from-sky-400",
    ingredients: [
      { name: "Omega-3 (EPA/DHA powder)", amount: "1,000 mg", benefit: "Inflammation control" },
      { name: "Berberine HCl", amount: "500 mg", benefit: "Metabolic health" },
      { name: "Trans-Resveratrol (micronized)", amount: "150 mg", benefit: "Cellular defense" },
      { name: "Urolithin A", amount: "250 mg", benefit: "Mitochondrial renewal" },
      { name: "Spermidine", amount: "1 mg", benefit: "Autophagy support" },
      { name: "Astaxanthin (microencapsulated)", amount: "6 mg", benefit: "Oxidative protection" },
    ],
  },
  {
    category: "Immune & Stress Resilience",
    icon: "ShieldCheck",
    bg: "bg-blue-50",
    fg: "text-royal",
    line: "from-blue-400",
    ingredients: [
      { name: "Reishi Mushroom Extract", amount: "300 mg", benefit: "Immune modulation" },
      { name: "Chaga Mushroom Extract", amount: "300 mg", benefit: "Antioxidant defense" },
    ],
  },
];

export const TOTAL_ACTIVES = INGREDIENT_GROUPS.reduce((s, g) => s + g.ingredients.length, 0);
export const TOTAL_SYSTEMS = INGREDIENT_GROUPS.length;
